import type { ActivityModule } from '../../core/activity';
import { mountGnumchPrimes } from './ui';
import levelsData from './levels.json';
import '../gnumch-equality/style.css';

export const gnumchPrimes: ActivityModule = {
  id: 'gnumch-primes',
  title: 'Comilão de primos',
  description: 'Coma só os números primos (que só são divisíveis por 1 e por eles mesmos). Cuidado com os fantasmas!',
  ageMin: 9,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/gnumch-primes/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGnumchPrimes,
};
